import * as React from 'react';
import {connect} from 'react-redux';
import {BasePage} from '../reusableComponents/BasePage';
import {FileInputButton} from '../reusableComponents/FormComponents/FileInputButton';
import {isFormEmpty, dispatch} from '../../utils/generalUtils';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {OrgForm} from './OrgForm';
import {Async} from '../reusableComponents/Async';
import {Loader} from '../reusableComponents/Loader/Loader';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {actions} from 'react-redux-form';
import {IOrgModelProps} from '../../model/OrgModel';
import {createOrgInfo} from '../../services/organizationService';

export interface ICreateOrgProps {
    history: IHistory;
    Category: [];
    SubCategory: [];
}

export class CreateOrgImpl extends React.PureComponent<ICreateOrgProps, {}> {
    constructor(props: ICreateOrgProps) {
        super(props);
    }

    public resetForm = () => {
        dispatch(actions.reset('forms.createOrgForm'));
    }

    public refs: {
        file: FileInputButton;
        orgPic: OrgForm;
    };

    public handleSubmit = async (values: IOrgModelProps) => {
        if (isFormEmpty(values)) {
            return;
        }
        return await createOrgInfo(values, this.refs.orgPic.orgPic, this.props.history);
    }

    public render() {
        return <BasePage title="Create New Organization" icon="building">
            <Async
                identifier="CreateOrg"
                promise={() => {
                    return;
                }}
                content={
                    <OrgForm
                        id="CreateOrg"
                        loadDefaultValues={this.resetForm}
                        ref="orgPic"
                        Category={this.props.Category}
                        SubCategory={this.props.SubCategory}
                        model="forms.createOrgForm"
                        onSubmit={this.handleSubmit}
                    />
                }
                loader={<Loader type="async"/>}
                error={<ErrorPage/>}
            />
        </BasePage>;
    }
}

export function mapStateToProps(state) {
    return {};
}

export const CreateOrg = withRouter(connect<{}, {}, ICreateOrgProps>(mapStateToProps)(CreateOrgImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Organization/CreateOrg.tsx